var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBeach = function SvgBeach(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4324_105283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.286 1.82524L22.3022 1.23743L22.6593 0.699028C22.8236 0.451212 23.1686 0.37673 23.4296 0.53273L23.4678 0.555569C23.7289 0.711569 23.8074 1.03897 23.643 1.28678L23.286 1.82524Z",
    fill: "url(#paint0_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8809 20.774L9.6582 20.0435L18.3349 6.96875L19.5575 7.6993L10.8809 20.774Z",
    fill: "url(#paint1_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.144 8.76464L17.5971 10.6557L19.5576 7.6993L18.335 6.96875L17.144 8.76464Z",
    fill: "url(#paint2_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8739 1.41119C18.886 -0.971527 13.768 -0.246841 10.667 2.90594C10.008 3.57592 10.1496 4.6484 10.9668 5.13669C11.6341 5.53541 12.5127 5.38986 12.995 4.79772C15.8728 1.26524 20.0917 -0.251175 22.8739 1.41119Z",
    fill: "url(#paint3_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.874 1.41113C25.6562 3.07345 26.0401 7.34005 23.929 11.3306C23.5751 11.9995 23.8168 12.8143 24.4841 13.213C25.3013 13.7013 26.3813 13.3587 26.7328 12.505C28.3867 8.48757 26.8619 3.7938 22.874 1.41113Z",
    fill: "url(#paint4_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8738 1.41113C23.9173 2.03462 23.0071 5.23889 20.8414 8.91642C20.3241 9.79476 20.6184 10.9035 21.5156 11.4395L21.8723 11.6526C22.6479 12.116 23.6807 11.8368 24.0727 11.0504C26.0206 7.14204 25.591 3.0346 22.8738 1.41113Z",
    fill: "url(#paint5_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8741 1.41126C20.1569 -0.212257 16.0694 1.19618 13.1992 4.55349C12.6216 5.22903 12.803 6.2337 13.5787 6.69717L13.9353 6.91021C14.8325 7.44627 16.013 7.21875 16.6236 6.39618C19.1804 2.9524 21.8306 0.787774 22.8741 1.41126Z",
    fill: "url(#paint6_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8739 1.41098C21.8708 0.811601 19.3827 2.78893 16.9203 6.00232C16.1543 7.00195 16.4445 8.40936 17.5466 9.06783L17.9043 9.28154C19.0064 9.94 20.4688 9.57982 21.0871 8.49195C23.0747 4.99485 23.8771 2.01035 22.8739 1.41098Z",
    fill: "url(#paint7_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9751 14.8258H9.92295C9.51826 14.8258 9.13011 14.6732 8.84395 14.4015L3.37353 9.20895C2.94628 8.8034 2.25355 8.8034 1.8263 9.20895C1.39905 9.6145 1.39905 10.272 1.8263 10.6776L8.00459 16.5421C8.2052 16.7629 8.50183 16.9028 8.83305 16.9028H22.0013C22.6188 16.9028 23.1168 16.4172 23.0947 15.8264C23.0736 15.2636 22.5684 14.8258 21.9751 14.8258Z",
    fill: "url(#paint8_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11639 21.2585L9.56619 17.984C10.0416 17.5327 10.0416 16.801 9.56619 16.3497C9.09076 15.8984 8.31994 15.8984 7.84446 16.3497L4.39466 19.6243C3.91923 20.0755 3.91923 20.8072 4.39466 21.2585C4.87014 21.7098 5.64096 21.7098 6.11639 21.2585Z",
    fill: "url(#paint9_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25488 18.8078L6.97661 20.442L9.56622 17.984C10.0416 17.5327 10.0416 16.801 9.56622 16.3497C9.09079 15.8984 8.31997 15.8984 7.84449 16.3497L5.25488 18.8078Z",
    fill: "url(#paint10_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4768 21.2585L21.027 17.984C20.5516 17.5327 20.5516 16.801 21.027 16.3497C21.5024 15.8984 22.2732 15.8984 22.7487 16.3497L26.1985 19.6243C26.6739 20.0755 26.6739 20.8072 26.1985 21.2585C25.723 21.7098 24.9522 21.7098 24.4768 21.2585Z",
    fill: "url(#paint11_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3383 18.8078L23.6166 20.442L21.027 17.984C20.5516 17.5327 20.5516 16.801 21.027 16.3497C21.5024 15.8984 22.2732 15.8984 22.7487 16.3497L25.3383 18.8078Z",
    fill: "url(#paint12_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8069 18.2208H8.15344C7.48107 18.2208 6.93604 17.7034 6.93604 17.0652C6.93604 16.427 7.48112 15.9097 8.15344 15.9097H22.8068C23.4792 15.9097 24.0242 16.4271 24.0242 17.0652C24.0243 17.7034 23.4793 18.2208 22.8069 18.2208Z",
    fill: "url(#paint13_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.35657 11.2935L7.2979 17.8822C7.77333 18.3335 8.54415 18.3335 9.01964 17.8822C9.49506 17.431 9.49506 16.6993 9.01964 16.248L2.0783 9.65926C1.60287 9.20798 0.832051 9.20798 0.35657 9.65926C-0.118857 10.1105 -0.118857 10.8422 0.35657 11.2935Z",
    fill: "url(#paint14_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3911 24.8142V21.5524C27.3911 20.5173 26.5071 19.6782 25.4166 19.6782H21.7904C18.7643 19.6782 15.8759 20.8786 13.8232 22.9891L12.0483 24.8142H27.3911Z",
    fill: "url(#paint15_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.913742 20.271C5.45022 19.2283 10.3023 19.7033 14.4168 21.5928L15.0625 21.8893C17.9908 23.2341 21.287 23.9399 24.6386 23.9399H26.1423C26.8321 23.9399 27.3913 24.4011 27.3913 24.97C27.3913 25.5389 26.8321 26.0001 26.1423 26.0001H1.24904C0.559212 26.0001 0 25.5389 0 24.97V21.2634C0 20.8009 0.373596 20.3952 0.913742 20.271Z",
    fill: "url(#paint16_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1423 23.9401H24.6387C21.287 23.9401 17.9909 23.2343 15.0625 21.8895L14.4169 21.593C12.1536 20.5537 9.66715 19.9428 7.13281 19.7769C6.04236 19.7055 5.11133 20.4205 5.11133 21.3227C5.11133 23.0703 6.82919 24.4871 8.94826 24.4871H27.2452C27.0353 24.1618 26.6204 23.9401 26.1423 23.9401Z",
    fill: "url(#paint17_linear_4324_105283)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 24.9699C0 25.5388 0.559212 26 1.24904 26H26.1423C26.8321 26 27.3914 25.5388 27.3914 24.9699C27.3914 24.4009 26.8321 23.9398 26.1423 23.9398H24.6387C22.5745 23.9398 20.5315 23.6717 18.5824 23.1519H0V24.9699Z",
    fill: "url(#paint18_linear_4324_105283)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5854 15.8699C32.5854 17.0481 32.4244 18.1523 32.1431 19.1028C32.0578 19.391 31.6261 19.391 31.5408 19.1028C31.2596 18.1523 31.0985 17.048 31.0985 15.8699C31.0985 14.6918 31.2595 13.5875 31.5408 12.6371C31.6261 12.3488 32.0578 12.3488 32.1431 12.6371C32.4244 13.5875 32.5854 14.6918 32.5854 15.8699Z",
    fill: "url(#paint19_linear_4324_105283)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5407 19.1028C31.2594 18.1523 31.0983 17.048 31.0983 15.8699C31.0983 14.6918 31.2594 13.5875 31.5407 12.6371C31.5833 12.493 31.7125 12.4209 31.8418 12.4209V19.3189C31.7125 19.3189 31.5833 19.2469 31.5407 19.1028Z",
    fill: "url(#paint20_linear_4324_105283)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3363 16.3992C33.0807 17.5521 32.6834 18.6012 32.2019 19.4762C32.0559 19.7416 31.6335 19.6572 31.6126 19.3585C31.5436 18.3734 31.6256 17.2613 31.8813 16.1084C32.137 14.9556 32.5342 13.9065 33.0157 13.0314C33.1617 12.7661 33.5842 12.8505 33.6051 13.1491C33.674 14.1343 33.592 15.2463 33.3363 16.3992Z",
    fill: "url(#paint21_linear_4324_105283)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6117 19.3585C31.5427 18.3734 31.6248 17.2613 31.8804 16.1084C32.1361 14.9556 32.5334 13.9065 33.0149 13.0314C33.0879 12.8987 33.23 12.8535 33.3564 12.8788L31.8595 19.6289C31.733 19.6036 31.6222 19.5078 31.6117 19.3585Z",
    fill: "url(#paint22_linear_4324_105283)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9016 17.2322C33.3583 18.2915 32.7043 19.2175 32.0132 19.9552C31.8036 20.1789 31.4155 19.9996 31.4717 19.705C31.657 18.7336 32.0214 17.6738 32.5646 16.6144C33.1078 15.5551 33.7618 14.6292 34.453 13.8914C34.6625 13.6677 35.0507 13.8471 34.9945 14.1417C34.8091 15.1131 34.4448 16.1729 33.9016 17.2322Z",
    fill: "url(#paint23_linear_4324_105283)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4715 19.705C31.6569 18.7336 32.0212 17.6737 32.5644 16.6144C33.1076 15.5551 33.7617 14.6292 34.4528 13.8914C34.5576 13.7796 34.707 13.7685 34.8232 13.8222L31.6426 20.0245C31.5264 19.9707 31.4434 19.8523 31.4715 19.705Z",
    fill: "url(#paint24_linear_4324_105283)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7105 18.801C29.7618 18.801 29.8139 18.7925 29.8647 18.7744C30.0919 18.6935 30.207 18.4531 30.1218 18.2375L28.1369 13.2132C27.9953 12.8549 27.693 12.5851 27.3076 12.4729C26.9222 12.3608 26.5126 12.4235 26.1839 12.645L24.7114 13.6368C24.5135 13.7701 24.467 14.0305 24.6074 14.2183C24.7478 14.4061 25.022 14.4503 25.22 14.317L26.6924 13.3251C26.7971 13.2547 26.9274 13.2347 27.0501 13.2704C27.1729 13.3061 27.2691 13.392 27.3141 13.5061L29.299 18.5303C29.3652 18.6977 29.5326 18.801 29.7105 18.801Z",
    fill: "url(#paint25_linear_4324_105283)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3076 12.4727C27.5418 12.5408 27.745 12.6674 27.9004 12.8365L27.2198 13.3672C27.1732 13.3229 27.1156 13.2892 27.0501 13.2702C26.9719 13.2474 26.8906 13.2475 26.8147 13.2687L26.5393 12.4762C26.7856 12.4013 27.0519 12.3983 27.3076 12.4727Z",
    fill: "url(#paint26_linear_4324_105283)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0673 12.4253C27.1478 12.4336 27.2282 12.4484 27.3076 12.4715C27.3684 12.4892 27.427 12.511 27.4834 12.5363L27.09 13.2831C27.077 13.2779 27.0638 13.2729 27.0501 13.2689C27.0328 13.2639 27.0153 13.2601 26.9978 13.2573L27.0673 12.4253Z",
    fill: "url(#paint27_linear_4324_105283)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6787 14.585L30.1218 18.2378C30.207 18.4534 30.0919 18.6938 29.8647 18.7747C29.8139 18.7928 29.7618 18.8013 29.7105 18.8013C29.5326 18.8013 29.3652 18.6981 29.299 18.5306L27.7402 14.585H28.6787Z",
    fill: "url(#paint28_linear_4324_105283)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9946 19.1883C23.047 18.9735 23.166 18.7785 23.3362 18.6284L25.523 16.7002C25.9406 16.3321 26.4893 16.1274 27.0592 16.1274H30.7118C31.2817 16.1274 31.8304 16.3321 32.248 16.7002L34.4348 18.6284C34.605 18.7785 34.724 18.9735 34.7764 19.1883C34.4321 19.8257 33.741 20.2266 32.9865 20.2266H24.7846C24.03 20.2266 23.3389 19.8257 22.9946 19.1883Z",
    fill: "url(#paint29_linear_4324_105283)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9945 19.1881C23.3386 19.8254 24.0299 20.2264 24.7842 20.2264H25.9599C25.9371 20.147 25.916 20.0639 25.897 19.9772L25.9378 19.5625L27.2298 16.7384C27.3995 16.3674 27.7849 16.1274 28.2109 16.1274H27.0591C26.4893 16.1274 25.9405 16.332 25.523 16.7001L23.336 18.6284C23.1658 18.7784 23.0469 18.9733 22.9945 19.188V19.1881Z",
    fill: "url(#paint30_linear_4324_105283)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8735 19.9772C31.8546 20.064 31.8335 20.147 31.8107 20.2266H25.9597C25.9369 20.147 25.9158 20.064 25.8969 19.9772L25.9377 19.5626L27.2114 16.7782C27.3921 16.3831 27.8026 16.1274 28.2564 16.1274H29.514C29.9678 16.1274 30.3784 16.3831 30.5591 16.7782L31.8328 19.5626L31.8735 19.9772Z",
    fill: "url(#paint31_linear_4324_105283)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2151 25.3942V25.3945C25.2165 25.3955 25.2183 25.3969 25.2197 25.3979C25.5075 25.6024 25.8513 25.7241 26.2094 25.7565C27.0259 25.8302 27.931 25.8713 28.8846 25.8713C29.8382 25.8713 30.7432 25.8302 31.5597 25.7565C31.9179 25.7241 32.2616 25.6024 32.5495 25.3979C32.5509 25.3969 32.5526 25.3955 32.554 25.3945C32.554 25.3942 32.554 25.3942 32.554 25.3942C34.0394 24.3352 35 22.6494 35 20.7504C35 20.2092 34.922 19.6851 34.7761 19.188C34.6756 19.2364 34.5589 19.2704 34.4323 19.2861C33.6218 19.3862 32.747 19.4642 31.8247 19.5183C30.888 19.573 29.9021 19.6024 28.8846 19.6024C27.867 19.6024 26.8811 19.573 25.9448 19.5183C25.0221 19.4642 24.1473 19.3862 23.3368 19.2861C23.2106 19.2704 23.0949 19.2367 22.9944 19.1887C22.8573 19.6531 22.7797 20.1412 22.7702 20.645C22.734 22.587 23.7023 24.3155 25.2151 25.3942Z",
    fill: "url(#paint32_linear_4324_105283)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0798 25.3954V25.3957C27.0805 25.3967 27.0812 25.3981 27.0819 25.3991C27.2236 25.6036 27.3926 25.7254 27.5687 25.7578C27.9705 25.8315 28.4158 25.8725 28.8847 25.8725C29.3536 25.8725 29.7989 25.8315 30.2007 25.7578C30.3768 25.7254 30.5458 25.6036 30.6875 25.3991C30.6882 25.3981 30.6889 25.3967 30.6896 25.3957C30.6896 25.3954 30.6896 25.3954 30.6896 25.3954C31.4203 24.3365 31.8931 22.6506 31.8931 20.7516C31.8931 20.3289 31.8695 19.9165 31.8249 19.5195C30.8882 19.5742 29.9023 19.6036 28.8847 19.6036C27.8672 19.6036 26.8813 19.5742 25.9449 19.5195C25.9038 19.8835 25.8806 20.2602 25.8771 20.6462C25.8591 22.5882 26.3354 24.3168 27.0798 25.3954Z",
    fill: "url(#paint33_linear_4324_105283)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2412 23.5532C33.8213 24.2747 33.2445 24.9025 32.5541 25.3947V25.3951C32.5527 25.3961 32.551 25.3974 32.5496 25.3984C32.2617 25.6029 31.9179 25.7247 31.5598 25.7571C30.7433 25.8308 29.8382 25.8718 28.8846 25.8718C27.9311 25.8718 27.026 25.8308 26.2095 25.7571C25.8514 25.7247 25.5076 25.6029 25.2197 25.3984C25.2183 25.3974 25.2166 25.3961 25.2152 25.3951C25.2152 25.3947 25.2152 25.3947 25.2152 25.3947C24.5248 24.9025 23.9484 24.2746 23.5286 23.5532H34.2412Z",
    fill: "url(#paint34_linear_4324_105283)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7699 20.6443C22.7794 20.1405 22.8571 19.6524 22.9941 19.188C22.9942 19.188 22.9942 19.188 22.9943 19.188C23.0948 19.236 23.2104 19.2697 23.3365 19.2854C24.147 19.3855 25.0218 19.4636 25.9445 19.5176C26.4704 19.5483 27.0124 19.5708 27.5664 19.5848C27.5176 19.7526 27.4179 19.9087 27.2695 20.0304L23.5156 23.5304C23.0233 22.676 22.7504 21.6913 22.7699 20.6443Z",
    fill: "url(#paint35_linear_4324_105283)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0994 18.9192C26.5699 18.9192 26.1406 18.5118 26.1406 18.0092C26.1406 17.5066 26.5699 17.0991 27.0994 17.0991C27.6289 17.0991 28.0581 17.5066 28.0581 18.0092C28.0581 18.5118 27.6289 18.9192 27.0994 18.9192Z",
    fill: "url(#paint36_linear_4324_105283)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9907 17.6751L26.2042 18.3355C26.0152 17.8682 26.2593 17.3433 26.7512 17.1614C27.2432 16.9795 27.797 17.2095 27.9907 17.6751Z",
    fill: "url(#paint37_linear_4324_105283)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6941 20.2039C26.1646 20.2039 25.7354 19.7964 25.7354 19.2938C25.7354 18.7912 26.1646 18.3838 26.6941 18.3838C27.2236 18.3838 27.6528 18.7912 27.6528 19.2938C27.6528 19.7964 27.2236 20.2039 26.6941 20.2039Z",
    fill: "url(#paint38_linear_4324_105283)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3005 19.9986L26.0949 18.5835C26.5066 18.2706 27.1076 18.3319 27.4396 18.7216C27.7715 19.1113 27.709 19.682 27.3005 19.9986Z",
    fill: "url(#paint39_linear_4324_105283)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0916 20.2039C24.5621 20.2039 24.1328 19.7964 24.1328 19.2938C24.1328 18.7912 24.5621 18.3838 25.0916 18.3838C25.6211 18.3838 26.0503 18.7912 26.0503 19.2938C26.0503 19.7964 25.6211 20.2039 25.0916 20.2039Z",
    fill: "url(#paint40_linear_4324_105283)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4614 19.9788L25.7287 18.6133C26.1228 18.946 26.16 19.5187 25.811 19.8947C25.462 20.2707 24.8588 20.308 24.4614 19.9788Z",
    fill: "url(#paint41_linear_4324_105283)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6858 18.9192C24.1563 18.9192 23.7271 18.5118 23.7271 18.0092C23.7271 17.5066 24.1563 17.0991 24.6858 17.0991C25.2153 17.0991 25.6445 17.5066 25.6445 18.0092C25.6445 18.5118 25.2153 18.9192 24.6858 18.9192Z",
    fill: "url(#paint42_linear_4324_105283)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7825 17.7041L25.5859 18.3217C25.4046 18.7917 24.8571 19.0349 24.3604 18.8648C23.8638 18.6947 23.6059 18.1758 23.7825 17.7041Z",
    fill: "url(#paint43_linear_4324_105283)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8923 18.1267C25.3628 18.1267 24.9336 17.7193 24.9336 17.2167C24.9336 16.7141 25.3628 16.3066 25.8923 16.3066C26.4218 16.3066 26.8511 16.7141 26.8511 17.2167C26.8511 17.7193 26.4218 18.1267 25.8923 18.1267Z",
    fill: "url(#paint44_linear_4324_105283)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8877 16.3066V18.1265C25.3603 18.1241 24.9336 17.7177 24.9336 17.2166C24.9336 16.7154 25.3603 16.309 25.8877 16.3066Z",
    fill: "url(#paint45_linear_4324_105283)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8926 18.8407C25.624 18.8407 25.4063 18.634 25.4063 18.3791C25.4063 18.1242 25.624 17.9175 25.8926 17.9175C26.1612 17.9175 26.3789 18.1242 26.3789 18.3791C26.3789 18.634 26.1612 18.8407 25.8926 18.8407Z",
    fill: "url(#paint46_linear_4324_105283)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4324_105283",
    x1: 22.8705,
    y1: 0.975248,
    x2: 23.5024,
    y2: 1.39471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4324_105283",
    x1: 14.3002,
    y1: 13.7733,
    x2: 15.0885,
    y2: 14.2965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48B2E3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4324_105283",
    x1: 18.5774,
    y1: 11.2928,
    x2: 18.3069,
    y2: 7.94963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4324_105283",
    x1: 15.0457,
    y1: 0.659048,
    x2: 15.8919,
    y2: 2.10169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4324_105283",
    x1: 24.9043,
    y1: 8.03005,
    x2: 27.858,
    y2: 9.71817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4324_105283",
    x1: 22.1415,
    y1: 6.4549,
    x2: 24.2853,
    y2: 8.49837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4324_105283",
    x1: 16.7933,
    y1: 2.48965,
    x2: 18.702,
    y2: 5.07237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4324_105283",
    x1: 19.2829,
    y1: 4.36628,
    x2: 21.0426,
    y2: 6.54489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF637B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E63950"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4324_105283",
    x1: 12.3006,
    y1: 7.48377,
    x2: 12.3006,
    y2: 17.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4324_105283",
    x1: 5.81206,
    y1: 17.6943,
    x2: 7.79383,
    y2: 19.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4324_105283",
    x1: 6.77451,
    y1: 18.9996,
    x2: 7.95168,
    y2: 17.7594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "#734A23",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603813"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4324_105283",
    x1: 24.7789,
    y1: 17.6943,
    x2: 22.7971,
    y2: 19.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4324_105283",
    x1: 23.8187,
    y1: 18.9996,
    x2: 22.6415,
    y2: 17.7594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C6239",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5198,
    stopColor: "#734A23",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#603813"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4324_105283",
    x1: 15.4801,
    y1: 15.499,
    x2: 15.4801,
    y2: 18.3058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4324_105283",
    x1: 5.85826,
    y1: 12.663,
    x2: 3.87649,
    y2: 14.7508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C59B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A57C52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4324_105283",
    x1: 19.2002,
    y1: 21.2016,
    x2: 20.0987,
    y2: 24.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3591,
    stopColor: "#FDC5B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7611,
    stopColor: "#FBAE98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4324_105283",
    x1: 3.76534,
    y1: 19.2974,
    x2: 17.6282,
    y2: 28.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4324_105283",
    x1: 13.3686,
    y1: 20.725,
    x2: 9.01754,
    y2: 16.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4324_105283",
    x1: 13.6957,
    y1: 24.2813,
    x2: 13.6957,
    y2: 25.743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D07972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4324_105283",
    x1: 32.7542,
    y1: 15.5713,
    x2: 30.2761,
    y2: 16.4716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4324_105283",
    x1: 31.3046,
    y1: 15.938,
    x2: 33.5823,
    y2: 15.6108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07485E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4324_105283",
    x1: 33.5644,
    y1: 16.1403,
    x2: 30.9364,
    y2: 16.4873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_4324_105283",
    x1: 32.065,
    y1: 16.2159,
    x2: 34.3622,
    y2: 16.3901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07485E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_4324_105283",
    x1: 34.192,
    y1: 17.0323,
    x2: 31.5638,
    y2: 16.6948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_4324_105283",
    x1: 32.7196,
    y1: 16.7593,
    x2: 34.8845,
    y2: 17.5097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07485E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03232E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_4324_105283",
    x1: 29.0388,
    y1: 14.3867,
    x2: 28.1441,
    y2: 15.4339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_4324_105283",
    x1: 27.2509,
    y1: 12.5717,
    x2: 26.9388,
    y2: 13.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_4324_105283",
    x1: 27.2462,
    y1: 12.5603,
    x2: 26.9571,
    y2: 13.435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_4324_105283",
    x1: 28.9451,
    y1: 15.0076,
    x2: 28.9451,
    y2: 16.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9100",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_4324_105283",
    x1: 29.8463,
    y1: 16.3355,
    x2: 28.4764,
    y2: 20.8402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDECF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_4324_105283",
    x1: 26.1685,
    y1: 18.2003,
    x2: 28.4497,
    y2: 16.8384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_4324_105283",
    x1: 29.3462,
    y1: 18.4309,
    x2: 31.8485,
    y2: 17.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA68E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA68E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_4324_105283",
    x1: 29.3743,
    y1: 20.7177,
    x2: 25.7412,
    y2: 24.8599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DD39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90CC1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_4324_105283",
    x1: 27.5711,
    y1: 22.9345,
    x2: 33.8787,
    y2: 19.0446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BB00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_4324_105283",
    x1: 28.8849,
    y1: 24.2538,
    x2: 28.8849,
    y2: 25.7559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BB00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_4324_105283",
    x1: 22.9246,
    y1: 21.5124,
    x2: 26.0813,
    y2: 19.8878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BB00",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BB00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_4324_105283",
    x1: 27.4398,
    y1: 18.1506,
    x2: 26.2168,
    y2: 17.5844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_4324_105283",
    x1: 27.064,
    y1: 17.8129,
    x2: 26.8943,
    y2: 19.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_4324_105283",
    x1: 26.6586,
    y1: 19.6424,
    x2: 26.7878,
    y2: 18.3572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_4324_105283",
    x1: 26.8838,
    y1: 19.1999,
    x2: 25.4308,
    y2: 19.4805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_4324_105283",
    x1: 24.7138,
    y1: 19.318,
    x2: 26.0695,
    y2: 19.2279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_4324_105283",
    x1: 25.2107,
    y1: 19.4538,
    x2: 24.7479,
    y2: 18.1172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_4324_105283",
    x1: 24.5338,
    y1: 17.6905,
    x2: 25.0647,
    y2: 18.8797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_4324_105283",
    x1: 24.5829,
    y1: 18.1791,
    x2: 25.6396,
    y2: 17.1899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_4324_105283",
    x1: 26.1563,
    y1: 16.9661,
    x2: 25.2452,
    y2: 17.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E8FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_4324_105283",
    x1: 25.6884,
    y1: 17.1756,
    x2: 26.9579,
    y2: 17.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5DBFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1734,
    stopColor: "#8FC5E9",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    stopColor: "#56A4C8",
    stopOpacity: 0.454
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6955,
    stopColor: "#2D8DB1",
    stopOpacity: 0.696
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8853,
    stopColor: "#147EA2",
    stopOpacity: 0.885
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B799D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_4324_105283",
    x1: 26.2365,
    y1: 18.0527,
    x2: 25.5845,
    y2: 18.7395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDBF00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4324_105283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.3913,
    height: 26,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBeach);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/beach.d452b2904c171b871c32a16872a30562.svg";